import { Activities } from "src/modules/activity-log/activity";
import RoundButton from "../RoundButton";
import { ReactComponent as CloseIcon } from "./close.svg";

export default function CloseGroupButton({
  isDarkMode,
  mode,
  activity,
  ...rest
}) {
  let bg;
  if (
    mode === "audio" &&
    (activity === Activities.SLEEPING || activity === Activities.MOTION)
  ) {
    bg = "black8";
    if (isDarkMode) bg = "white20";
  } else {
    bg = "black20";
  }

  return (
    <RoundButton
      icon={CloseIcon}
      iconFill={
        mode === "video" || activity === Activities.AWAKE || isDarkMode
          ? "white"
          : "black54"
      }
      iconSize="50%"
      size={["24px", "32px", "40px"]}
      bg={bg}
      {...rest}
    />
  );
}
